import { selectors as stateSelectors } from 'mage-state'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import axios from 'axios'
import { handleEducationError } from 'education-tools'
import useCMSEnvironment from './useCMSEnvironment'
import * as selectors from '../selectors'
import {
  MERCHANT_PORTAL_SPACE_ID,
  MERCHANT_PORTAL_API_TOKEN,
  MERCHANT_PORTAL_API_TOKEN_PREVIEW
} from '../constants'

export default function useCMSRequest(resource, extraParams = {}, skip = false) {
  const preview = useSelector(selectors.preview)
  const locale = useSelector(stateSelectors.cmsLocale)
  const environment = useCMSEnvironment()

  const params = {
    locale,
    ...extraParams
  }

  const apiToken = preview ? MERCHANT_PORTAL_API_TOKEN_PREVIEW : MERCHANT_PORTAL_API_TOKEN

  const [result, setResult] = useState(null)

  useEffect(() => {
    if (!environment) return

    const url = buildUrl(environment, preview, resource)

    if (!skip) {
      setResult(null)
      fetch(apiToken, setResult, url, params)
    }
  }, [environment, preview, resource, JSON.stringify(params), skip])

  return result
}

function buildUrl(environment, preview, resource) {
  const baseURL = preview ? 'https://preview.contentful.com' : 'https://cdn.contentful.com'

  const space = MERCHANT_PORTAL_SPACE_ID
  const path = `/spaces/${space}/environments/${environment}${resource}`

  return `${baseURL}${path}`
}

function fetch(apiToken, setResult, url, params) {
  const client = axios.create({
    timeout: 10000,
    headers: {
      Authorization: `Bearer ${apiToken}`
    }
  })

  client
    .request({ method: 'GET', url, params })
    .then(response => response.data)
    .then(setResult)
    .catch(error => {
      handleEducationError(error)

      // Retry on rate limit failure
      if (error.response && error.response.status === 429) {
        setTimeout(() => fetch(apiToken, setResult, url, params), 1000)
      }
    })
}
